import * as React from 'react';

import { once } from 'lodash';

import AdminSchoolSisSyncHeader from 'admin/rostering/components/AdminSchoolSisSyncHeader';
import Image from 'components/Image';
import EventTracking from 'lib/EventTracking';

type Props = {
  orgUuid: string;
  status: 'processing' | 'failed';
  subtext: React.ReactElement;
};

export default class AdminSisSyncProcessingView extends React.Component<Props> {
  componentWillMount() {
    this.trackView();
  }

  trackView = once(() => {
    EventTracking.view('rostering.sis_dash.processing.view', {
      organization_uud: this.props.orgUuid,
    });
  });

  render() {
    this.trackView();

    return (
      <section className="AdminSisSyncProcessingView">
        <AdminSchoolSisSyncHeader subtext={this.props.subtext} status={this.props.status} />
        <Image src={require('assets/images/admin/AdminSisSyncProcessingView/banner.svg')} />
      </section>
    );
  }
}
